import * as React from 'react';
import SVGIcon from '../SVGIcon';

interface Props {}

const StarIcon: React.FC<Props> = () => {
  return (
    <SVGIcon width="18" height="20" viewBox="0 0 21 20">
      <path
        d="M17.7585 -0.000488281H3.73755C2.22705 -0.000488281 0.998047 1.22901 0.998047 2.74051V16.7715C0.998047 18.283 2.22705 19.5125 3.73755 19.5125H17.7585C19.269 19.5125 20.498 18.283 20.498 16.7715V2.74051C20.498 1.22901 19.269 -0.000488281 17.7585 -0.000488281ZM18.086 8.61601L14.265 11.392L15.7245 15.8835C15.825 16.1925 15.7145 16.531 15.452 16.722C15.3205 16.8175 15.166 16.8655 15.011 16.8655C14.856 16.8655 14.7015 16.8175 14.57 16.722L10.75 13.9465L6.92955 16.722C6.66655 16.913 6.31105 16.913 6.04755 16.722C5.78505 16.531 5.67455 16.1925 5.77505 15.8835L7.23455 11.3915L3.41355 8.61601C3.15105 8.42501 3.04055 8.08651 3.14105 7.77751C3.24155 7.46851 3.52955 7.25901 3.85455 7.25901H8.57705L10.036 2.76801C10.137 2.45901 10.425 2.25001 10.75 2.25001C11.075 2.25001 11.363 2.45901 11.4635 2.76851L12.9225 7.25951H17.645C17.97 7.25951 18.258 7.46851 18.3585 7.77801C18.4585 8.08701 18.3485 8.42551 18.086 8.61601Z"
        fill="#0E0E0E"
      />
    </SVGIcon>
  );
};

export default StarIcon;
